"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuoteDataReducer = exports.InitialQuoteData = exports.DataPersister = void 0;
var _petDetailsReducer = require("./petDetailsReducer");
var _ownerDetailsReducer = require("./ownerDetailsReducer");
var _routeStatesReducer = require("./routeStatesReducer");
var _basePropTypes = require("../types/propTypes/basePropTypes");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var InitialQuoteData = exports.InitialQuoteData = {
  owner: _objectSpread({}, _basePropTypes.emptyOwnerQuoteDetails),
  pets: [_objectSpread(_objectSpread({}, _basePropTypes.emptyPetDetails), {}, {
    quotes: []
  })],
  quotesContext: {
    paymentFrequency: 'MONTHLY',
    hasPromotionCode: false,
    promotionCode: '',
    promotionMessage: '',
    collectionFee: 2
  },
  routeStates: _routeStatesReducer.InitialRouteStates
};
var DataPersister = exports.DataPersister = {
  sessionStorageKey: function sessionStorageKey() {
    var storageKey = sessionStorage.getItem('PetSureQuoteStorageKey');
    if (storageKey) {
      return storageKey;
    }
    var newKey = "PetSure".concat(Date.now());
    sessionStorage.setItem('PetSureQuoteStorageKey', newKey);
    return newKey;
  },
  getStoredData: function getStoredData() {
    var storedData = sessionStorage.getItem(DataPersister.sessionStorageKey());
    if (storedData) {
      return JSON.parse(storedData);
    }
    return null;
  },
  setStoredData: function setStoredData(data) {
    sessionStorage.setItem(DataPersister.sessionStorageKey(), JSON.stringify(data));
  }
};
var QuoteDataReducer = exports.QuoteDataReducer = function QuoteDataReducer(state, action) {
  var updatedState = state;
  if (_petDetailsReducer.PetDetailsReducer[action.type]) {
    updatedState = _petDetailsReducer.PetDetailsReducer[action.type](state, action);
  }
  if (_ownerDetailsReducer.OwnerDetailsReducer[action.type]) {
    updatedState = _ownerDetailsReducer.OwnerDetailsReducer[action.type](state, action);
  }
  if (_routeStatesReducer.RouteStatesReducer[action.type]) {
    updatedState = _routeStatesReducer.RouteStatesReducer[action.type](state, action);
  }
  switch (action.type) {
    case 'applyApplicationContextData':
      updatedState = _objectSpread(_objectSpread({}, state), action.initialQuoteContext);
      break;
    case 'applyMockData':
      updatedState = action.mockData;
      break;
    case 'updateQuote':
      // TODO: Hook up to API
      break;
    case 'handleProductSelect':
      // TODO: Hook up to API
      break;
    case 'getQuote':
      // TODO: Hook up to API
      break;
    case 'saveQuoteForLater':
    default:
      // TODO: Hook up to local storage
      break;
  }
  DataPersister.setStoredData(updatedState);
  return updatedState;
};